import React, { useCallback, useMemo, useState } from "react";
import { Grid, IconButton, TableCell, Tooltip } from "@mui/material";
import FormTextTC from "../../components/Forms/FormTextTC";
import FormV2 from "../JamezzForm/FormV2";
import MainNavbar from "../../components/Navbars/MainNavbar";
import JamezzTableV2, { useReloadState } from "../../components/JamezzTable/V2/JamezzTableV2";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import { AddCircle, Https, RemoveCircle } from "@mui/icons-material";
import { _request } from "../../http";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import useJTFilter from "../../components/JamezzTable/V2/useJTFilter";

const endPoint = "core/roles";

function RoleForm({ classes }) {
  const [role, setRole] = useState(null);
  const { reloadState, updateReloadState } = useReloadState();

  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },
      {
        id: "name",
        label: <TranslationWrapper tDefault={"Permission name"} tKey={"permissions.name"} />,
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
    ],
    []
  );

  const renderRowCells = useCallback((row) => {
    return (
      <>
        <TableCell align={"right"} style={{ width: 100 }}>
          {row.id}
        </TableCell>
        <TableCell>{row.name}</TableCell>
      </>
    );
  }, []);

  const renderSelectionActions = useCallback(
    (selected) => {
      return (
        <Tooltip title={<TranslationWrapper tKey={"Remove"} />}>
          <IconButton
            onClick={() => {
              _request(
                "patch",
                `core/roles/${role.id}`,
                {
                  permissions__id: { detach: Object.keys(selected).map((index) => selected[index]) },
                },
                null
              ).then(() => {
                updateReloadState();
              });
            }}
            style={{ color: "lightcoral" }}
          >
            <RemoveCircle />
          </IconButton>
        </Tooltip>
      );
    },
    [role]
  );

  const renderSelectionActionsAdd = useCallback(
    (selected) => {
      return (
        <Tooltip title={<TranslationWrapper tKey={"Add"} />}>
          <IconButton
            onClick={() => {
              _request(
                "patch",
                `core/roles/${role.id}`,
                {
                  permissions__id: { attach: Object.keys(selected).map((index) => selected[index]) },
                },
                null
              ).then(() => {
                updateReloadState();
              });
            }}
            style={{ color: "#07bc0c" }}
          >
            <AddCircle />
          </IconButton>
        </Tooltip>
      );
    },
    [role]
  );

  const renderRowActions = useCallback((row) => {
    return (
      <TableCell align={"right"}>
        <Link to={`/manager/permissions/${row.id}/edit`}>
          <Tooltip
            classes={{ tooltip: classes.tooltip }}
            placement={"bottom"}
            title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
          >
            <IconButton color={"primary"} simple size={"small"}>
              <Edit />
            </IconButton>
          </Tooltip>
        </Link>
      </TableCell>
    );
  }, []);

  const defaultFilter1 = useMemo(
    () => ({
      "roles.id": { field: "roles.id", operator: "=", value: role?.id },
    }),
    [role]
  );
  const [textField1, filters1] = useJTFilter("name", defaultFilter1);
  const defaultFilter2 = useMemo(
    () => ({
      "roles.id": {
        operator: "or",
        value: [
          { field: "roles.id", has: false },

          { field: "roles.id", operator: "=", value: role?.id, has: false },
        ],
      },
    }),
    [role]
  );
  const [textField2, filters2] = useJTFilter("name", defaultFilter2);

  return (
    <>
      <MainNavbar paginaTitel={"Role "} subject={role?.name} />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <FormV2
            endPoint={endPoint}
            mode={"onSubmit"}
            onGetModel={(role) => {
              setRole(role);
            }}
            revalidateMode={"onChange"}
          >
            <Grid container spacing={1}>
              <FormTextTC name={"name"} tDefault={"Role name"} tKey={"roles.name"} />
            </Grid>
          </FormV2>
        </Grid>
        <Grid item lg={6} xs={12}>
          {role ? (
            <>
              {textField1}
              <JamezzTableV2
                checkboxSelection={true}
                dense={true}
                endPoint={"core/permissions"}
                filters={filters1}
                headerIcon={<Https />}
                reloadState={reloadState}
                renderCellsForRow={renderRowCells}
                renderHeaderCells={renderHeaderCells}
                renderRowActions={renderRowActions}
                renderSelectionActions={renderSelectionActions}
                rowIsEditable={() => false}
                rowIsSelectable={() => true}
                tableTitle={<TranslationWrapper tKey={"Role has permissions"} />}
                uuid={"RoleForm-a091uejws"}
              />
            </>
          ) : null}
        </Grid>

        <Grid item lg={6} xs={12}>
          {role ? (
            <>
              {textField2}
              <JamezzTableV2
                checkboxSelection={true}
                dense={true}
                endPoint={"core/permissions"}
                filters={filters2}
                headerIcon={<Https />}
                reloadState={reloadState}
                renderCellsForRow={renderRowCells}
                renderHeaderCells={renderHeaderCells}
                renderRowActions={renderRowActions}
                renderSelectionActions={renderSelectionActionsAdd}
                rowIsEditable={() => false}
                rowIsSelectable={() => true}
                tableTitle={<TranslationWrapper tKey={"Add new permissions"} />}
                uuid={"RoleForm-1wsasdsdec23"}
              />
            </>
          ) : null}
        </Grid>
      </Grid>
    </>
  );
}

export default withStyles(RoleForm, vestigingStyle);
